<template>
  <footer class="p-4" v-show="isFaimDeSaison">
    <div class="footer-inner">      
      
      <router-link 
      v-if="hasPartenaires"
      :to="{name: 'partenaires'}"
      class="lg:inline-block lg:mt-0 text-teal-lighter"
      
      >
        Partenaires
      </router-link>

      <span v-if="hasPartenaires" class="only-on-mobile-inline inline-separator"> · </span>

      <router-link 
      v-if="hasTermsAndConditions"
      :to="{name: 'termsAndConditions'}"
      class="lg:inline-block lg:mt-0 text-teal-lighter"
      title="Conditions générales de vente"
      >
        CGV
      </router-link>

      <span v-if="hasTermsAndConditions" class="only-on-mobile-inline inline-separator"> · </span>

      <router-link 
      v-if="hasLegal"
      :to="{name: 'legal'}"
      class="lg:inline-block lg:mt-0 text-teal-lighter"
      >
        Mentions légales
      </router-link>
      
      <span v-if="hasLegal" class="only-on-mobile-inline inline-separator"> · </span>
      
      <router-link 
      v-if="hasAllergenes"
      :to="{name: 'allergenes'}"
      class="lg:inline-block lg:mt-0 text-teal-lighter">
        Allergènes
      </router-link>
      <span v-if="hasAllergenes" class="only-on-mobile-inline inline-separator"> · </span>

      <a 
        href="https://www.instagram.com/sabrinapellouxprayer/"
        target="_blank"
        class="lg:inline-block lg:mt-0 text-teal-lighter"
      >
        Identité graphique : Sabrina<span class="hide-on-mobile">  Pelloux-Payer</span>
      </a>

      <span class="only-on-mobile-inline inline-separator"> · </span>

      <span
        class="lg:inline-block lg:mt-0 text-teal-lighter footer-as-a"
      >
        {{ isMobile ? 'Photos' : 'Crédit photos' }} : <a href="https://www.instagram.com/nadege.depriester/" target="_blank">Nadège<span class="hide-on-mobile">  Depriester</span></a>, <a href="https://www.faimdesaison.fr/a-propos">Sophie<span class="hide-on-mobile"> Minotto</span></a>
    </span>
      <!--
      <a 
      href="https://fr.linkedin.com/in/minotto"
      target="_blank"
      class="block lg:inline-block lg:mt-0 text-teal-lighter hide-on-mobile">
        Copyright {{ year }}
      </a>
      -->
    </div>
  </footer>
</template>

<script>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useAdminDataStore } from '../stores/admin';
import { useFrontDataStore } from '../stores/front';
import useIsMobile from '../misc/useIsMobile';

export default {
  name: "About",
  setup() {
    const adminDataStore = useAdminDataStore();
    const frontDataStore = useFrontDataStore();

    const { isAuthenticated } = storeToRefs(adminDataStore);
    const isMobile = useIsMobile();
    const isFaimDeSaison = computed(() => process.env.VUE_APP_SKIN_NAME === 'faim2s');

    const { pages } = storeToRefs(frontDataStore);
    const hasPartenaires = false && computed(() => (pages.value['partenaires'] || {}).descriptionGeneratedHtml != '');    
    const hasTermsAndConditions = false && computed(() => (pages.value['termsAndConditions'] || {}).descriptionGeneratedHtml != '');    
    const hasLegal = computed(() => (pages.value['legal'] || {}).descriptionGeneratedHtml != '');    
    const hasAllergenes = false && computed(() => (pages.value['allergenes'] || {}).descriptionGeneratedHtml != '' && (pages.value['allergenes'] || {}).descriptionGeneratedHtml != '<p class="PlaygroundEditorTheme__paragraph"><br></p>' );


    return {
      isAuthenticated,
      isFaimDeSaison,
      isMobile,
      hasPartenaires,
      hasTermsAndConditions,
      hasLegal,
      hasAllergenes,
      year: new Date().getFullYear(),
    };
  }
};
</script>